import React, { Component } from "react";
import { connect } from "react-redux";
import translator from "../../utils/translator";

class TestPage extends Component {
	render() {
		return (
			<div>
				{
					translator("Misc", "choose_ship_to_btn")
				}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TestPage);
